export default [
  {
    path: '/outils/gestion-cabinet',
    name: 'gestion-cabinet',
    component: () => import('@/views/outils/gestion-cabinet/GestionCabinet.vue'),
  },
  {
    path: '/outils/gestion-interlocuteurs',
    name: 'gestion-interlocuteurs',
    component: () => import('@/views/outils/gestion-collaborateurs/GestionCollaborateurs.vue'),
  },
  {
    path: '/cabinet/fiche-demande-ouverture-code',
    name: 'fiche-demande-ouverture-code',
    component: () => import('@/views/demandes/FicheDemandeOuvertureCode.vue'),
  },

  {
    path: '/cabinet/beneficier-un-pack-de-formation-dda/:cu/:expire_token_url',
    name: 'beneficier-un-pack-de-formation-dda',
    component: () => import('@/views/formationdda/FicheGagnePackFormation.vue'),
  },
  
]
